<template>
  <div class="com-page">
    <div class="com-content">
      <el-button class="back" plain @click="pageBack">
        <i class="iconfont iconzu131" />返回
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'materialHeader',
  data () {
    return {}
  },
  methods: {
    pageBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.com-page {
  height: 100px;
  box-sizing: border-box;
  color: $base-white;
  background: url("../../../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
  position: relative;
  .com-content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    width: 1200px;
    height: 100%;
    margin: auto;
    .back {
      color: $base-yellow;
      border-width: 0px;
      font-weight: 700;

      & :hover {
        background-color: $base-white;
        color: $base-red;
        border-color: $base-white;
      }
      &:active,
      &::after {
        background-color: $base-white;
        color: $base-red;
        border-color: $base-white;
      }
      &:focus {
        background-color: $base-white;
        color: $base-red;
        outline: none;
        border-color: $base-white;
      }
    }
  }
}
</style>
